var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXverseIconWhitecolor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M298.418 293.613V239.294C298.418 237.14 297.562 235.086 296.036 233.56L64.9159 2.43899C63.3897 0.912729 61.3354 0.0568848 59.1816 0.0568848H4.86405C2.1824 0.0568848 0 2.23929 0 4.92093V55.3873C0 57.5412 0.855845 59.5951 2.3821 61.1214L85.3421 144.081C87.2391 145.979 87.2391 149.06 85.3421 150.957L1.42641 234.872C0.513507 235.785 0 237.026 0 238.31V293.613C0 296.292 2.1824 298.477 4.86405 298.477H95.6263C98.308 298.477 100.49 296.292 100.49 293.613V261.033C100.49 259.749 101.004 258.508 101.917 257.595L146.934 212.577C148.831 210.68 151.912 210.68 153.81 212.577L237.34 296.109C238.866 297.635 240.92 298.491 243.074 298.491H293.54C296.222 298.491 298.404 296.307 298.404 293.627L298.418 293.613Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M177.345 71.9901H222.805C225.5 71.9901 227.697 74.1868 227.697 76.8828V122.342C227.697 126.707 232.975 128.89 236.056 125.794L298.418 63.3321C299.33 62.419 299.846 61.1782 299.846 59.88V5.17727C299.846 2.48137 297.661 0.2847 294.952 0.2847L239.436 0.213379C238.139 0.213379 236.898 0.726885 235.97 1.63979L173.879 63.6315C170.798 66.7125 172.98 71.9901 177.331 71.9901H177.345Z",
    fill: "#EE7A30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXverseIconWhitecolor);
export default __webpack_public_path__ + "static/media/xverse_icon_whitecolor.f02ac6d5ccdee9b226d9934b4aef555a.svg";
export { ForwardRef as ReactComponent };